/* RESPONSIBLE TEAM: team-ai-agent */

import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { type Router } from '@ember/routing';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';

class StandaloneIssuesRoute extends Route {
  @service declare appService: AppService;
  @service declare router: Router;

  analytics = {
    section: 'standalone',
    place: 'issues',
  };

  reactEnabled() {
    return true;
  }

  async beforeModel() {
    if (!this.appService.app.canSeeIncidentDetection) {
      this.router.transitionTo('apps.app.standalone.performance');
    }
  }
}

export default ReactRoute(StandaloneIssuesRoute);
